import React, { useEffect } from 'react';
import { useQuery } from "graphql-hooks";
import { Row, Col, Button, Card, CardBody, CardTitle, CardImg } from 'reactstrap';
import Helper from '../../utilities/helper'
import { useLocation } from 'react-router-dom';
import { Loading } from '../Shared/Loading';
import { MetaTags } from "../Shared/MetaTags";
import { ErrorPage } from '../Shared/ErrorPage';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { Hero } from '../Shared/Hero';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentBody } from '../Shared/Content/ContentBody';
import { useAPIErrorContext } from '../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
    pageData: pageNews {
        fieldHeroTitle
        fieldDisclaimer
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
    allCollectionNews ( orderBy: fieldReferenceDate_DESC, first: "9" ) {
        fieldImage {
            url
            filename
            alt
            title
            width
            height
            smartTags
            focalPoint {
                x
                y
            }
            responsiveImage {
                aspectRatio
                height
                width
                alt
                title
            }
        }
        fieldTitle
        fieldSubtitle
        fieldSummary
        fieldReferenceDate
        fieldUrl
    }
}`;

export const NewsAndEvents = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();

    const location = useLocation();
    useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    useEffect(() => {
        console.log("stuff: ", data);
    }, [data]);

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.NewsAndEvents}>
                <div className="newsAndEventsContainer">
                    <Hero pageTitle={data.pageData.fieldHeroTitle} />
                    <ContentBlock className="newsAndEvents">
                        <ContentBody>
                            {data.pageData.fieldDisclaimer &&
                                <div dangerouslySetInnerHTML={{ __html: data.pageData.fieldDisclaimer }} />
                            }
                            <div className="heading5 disclaimer" dangerouslySetInnerHTML={{ __html: data.pageData.field_disclaimer }}></div>
                            <Row className="contentCardBlock newsCard d-flex justify-content-between">
                                    {
                                        data.allCollectionNews.map((data: any, index: number) => {
                                            return (
                                                <Col className="newsColumn" key={index} sm={12} md={6} lg={4}>
                                                    <Card>
                                                        {(() => {
                                                            // check if image data exists coming from CMS
                                                            if (data.fieldImage !== undefined && data.fieldImage !== null) {
                                                                return (
                                                                    <div className={'cardImageContainer'}>
                                                                        {/* build image element */}
                                                                        <CardImg variant="top" style={{ objectPosition: (data.fieldImage.focalPoint.x * 100) + '% ' + (data.fieldImage.focalPoint.y * 100) + '% ' }} src={data.fieldImage.url} alt={data.fieldImage.alt} title={data.fieldImage.title} />
                                                                    </div>
                                                                );
                                                            }
                                                        })()}
                                                        <CardBody className="cardBody">
                                                            <CardTitle className="cardHeading">
                                                                <div className="heading5">{data.fieldTitle}</div>
                                                            </CardTitle>
                                                            <div className="cardBodyText" dangerouslySetInnerHTML={{ __html: data.fieldSummary }}></div>
                                                            <div className="cardDate"> Posted {Helper.formatAsDateOnly(data.fieldReferenceDate)}</div>
                                                        </CardBody>
                                                        <div className="cardButton">
                                                            <Button className="tertiaryButton iconRightArrow" href={data.fieldUrl} target={'_blank'}>READ FULL ARTICLE</Button>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            );
                                        })
                                    }
                                </Row>
                        </ContentBody>
                    </ContentBlock>
                    {/* set meta tags */}
                    <MetaTags seoData={data.pageData.seo} />
                </div>
            </PermissionsGate>
        );

    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
